module.exports = __webpack_public_path__ + "static/Pure-React-2ae66651f664cdfe14990eb1d800621f.png";